import { SMALL } from "./break-points";

// eslint-disable-next-line import/prefer-default-export
export const SMALL_SCREEN_MEDIA_CONDITION = `(max-width:${SMALL}px)`;
